import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGeneralmotorsComponent } from './simple-icons-generalmotors.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGeneralmotorsComponent ],
    exports:      [ SimpleIconsGeneralmotorsComponent ],
    bootstrap:    []
})
export class SimpleIconsGeneralmotorsModule {}
